import script from "./spointsDeduc.vue?vue&type=script&setup=true&lang=js"
export * from "./spointsDeduc.vue?vue&type=script&setup=true&lang=js"

import "./spointsDeduc.vue?vue&type=style&index=0&id=e49ea0f6&lang=scss"

const __exports__ = script;

export default __exports__